<template>
  <div id="search-bar-iframe">
    <location-card iframeMode></location-card>
  </div>
</template>
<script>
import SearchBarIframe from "@/views/SearchBarIframe/SearchBarIframe";
export default SearchBarIframe;
</script>

<style lang="scss">
@import "SearchBarIframe.scss";
</style>
